<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2">
                    轉出
                </h4>
                <div class="grid lg:gap-x-4 grid-cols-1 lg:grid-cols-2 text-base xs:text-lg">
                    <template
                        v-for="(item,idx) in exportList"
                        :key="idx"
                    >
                        <ResultList>
                            <li class="text-gray-900">
                                {{ item.fundCode }} {{ item.fundName }} {{ `(${item.currencyText})` }}
                            </li>
                            <li
                                v-if="item.unit !==0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">轉出(單位數)</span>
                                <span>{{ item.unit }}</span>
                            </li>
                            <li
                                v-if="item.percent !==0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">轉出(比例)</span>
                                <span>{{ item.percent }}%</span>
                            </li>
                            <li class="flex items-baseline justify-between text-gray-700">
                                <span class="text-sm">預估轉出金額({{ policy.currencyText }})</span>
                                <span>{{ addComma(item.amount) }}</span>
                            </li>
                        </ResultList>
                    </template>
                </div>
                <h4 class="mb-2 mt-2 md:mt-0">
                    轉入
                </h4>

                <div class="grid lg:gap-x-4 grid-cols-1 lg:grid-cols-2 text-base xs:text-lg">
                    <template
                        v-for="(item,idx) in importList"
                        :key="idx"
                    >
                        <ResultList>
                            <li class="text-gray-900">
                                {{ item.fundCode }} {{ item.fundName }} {{ `(${item.currencyText})` }}
                            </li>
                            <li
                                v-if="item.unit !==0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">轉入(單位數)</span>
                                <span>{{ item.unit }}</span>
                            </li>
                            <li
                                v-if="item.percent !==0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">轉入(比例)</span>
                                <span>{{ item.percent }}%</span>
                            </li>
                            <li class="flex items-baseline justify-between text-gray-700">
                                <span class="text-sm">預估轉入金額({{ policy.currencyText }})</span>
                                <span>{{ addComma(item.amount) }}</span>
                            </li>
                        </ResultList>
                    </template>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, reactive, computed } from 'vue';
import { addComma } from '@/utils/number/addComma';
import { useStore } from 'vuex';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';

export default {
    name: 'A6Data',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const store = useStore();
        const policy = computed(() => store.state.policy.policy);
        const data = toRef(props, 'result');
        const code = ref('A6');
        const after = reactive(data.value.after);
        const exportList = computed(() => {
            const list = [];
            after.transformResultDataList.forEach(i => {
                if (i.transMode === '2') list.push(i);
            });
            return list;
        });
        const importList = computed(() => {
            const list = [];
            after.transformResultDataList.forEach(i => {
                if (i.transMode === '3') list.push(i);
            });
            return list;
        });

        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, after, exportList, importList, addComma, removeService, policy };
    },
};
</script>
